import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import NotifierContainer from '@softwaredev_cegeka/stix-notifier/dist/components/NotifierContainer'

import { reverse, routeConfig } from './config'
import Header from 'src/components/Header'
import { NotFound, InternalServerError } from './Error'
import { ContentRoute } from './ContentRoute'
import withUserData from 'src/components/auth/withUserData'

class Main extends React.Component {
    render() {
        return (
            <>
                <NotifierContainer
                    position="fixed"
                    defaults={{
                        autohide: true,
                        position: 'fixed',
                    }}
                />
                <Header />
                {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                {/* <Route
                    exact
                    path={'/internal-error'}
                    component={InternalServerError}
                /> */}
                <Route>
                    <Sentry.ErrorBoundary fallback={InternalServerError}>
                        <Switch>
                            {routeConfig.map((route, index) => {
                                if (route.permissions instanceof Function) {
                                    if (
                                        !route.permissions(this.props.userData)
                                    ) {
                                        return (
                                            <Redirect
                                                to={reverse('unauthorized')}
                                            />
                                        )
                                    }
                                }
                                let breadcrumbs = route.breadcrumbs
                                if (
                                    route.organizationBreadcrumbs instanceof
                                    Function
                                ) {
                                    breadcrumbs = route.organizationBreadcrumbs(
                                        this.props.userData
                                    )
                                }
                                return (
                                    <ContentRoute
                                        key={index}
                                        match={this.props.match}
                                        path={route.path}
                                        component={route.component}
                                        title={route.title}
                                        name={route.name}
                                        breadcrumbs={breadcrumbs}
                                    />
                                )
                            })}
                            <Route component={NotFound} />
                        </Switch>
                    </Sentry.ErrorBoundary>
                </Route>
            </>
        )
    }
}

export default withUserData(Main)
